exports.components = {
  "component---src-pages-checkout-jsx": () => import("./../../../src/pages/checkout.jsx" /* webpackChunkName: "component---src-pages-checkout-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-privacy-jsx": () => import("./../../../src/pages/privacy.jsx" /* webpackChunkName: "component---src-pages-privacy-jsx" */),
  "component---src-pages-sp-jsx": () => import("./../../../src/pages/sp.jsx" /* webpackChunkName: "component---src-pages-sp-jsx" */),
  "component---src-pages-tos-jsx": () => import("./../../../src/pages/tos.jsx" /* webpackChunkName: "component---src-pages-tos-jsx" */),
  "component---src-pages-typ-jsx": () => import("./../../../src/pages/typ.jsx" /* webpackChunkName: "component---src-pages-typ-jsx" */)
}

